import React from 'react';
import useTheme from 'branding/theme';
const Circle = ({ size = 'regular', kind = 'regular', inverted = false, disabled = false, colorOverride, backgroundColorOverride, children, styles, ...rest }) => {
    const { borders, sizing, colors } = useTheme();
    const color = disabled
        ? colors.neutrals.borderBeta
        : colorOverride
            ? colorOverride
            : kind === 'regular'
                ? colors.brand.primary.alpha
                : colors.status[kind].alpha;
    const backgroundColor = backgroundColorOverride
        ? backgroundColorOverride
        : inverted
            ? colors.neutrals.transparent
            : color;
    const width = size === 'tiny' ? 16 : sizing.widths.circle[size];
    const mergedStyles = {
        ...borders.base,
        ...borders.shape.pill,
        minWidth: width,
        borderColor: color,
        backgroundColor,
        ...styles
    };
    return (React.createElement("svg", { viewBox: "0 0 2 2", width: width, style: mergedStyles, ...rest },
        React.createElement("circle", { cx: "1", cy: "1", r: "1", fill: backgroundColor }),
        children));
};
export default Circle;
//# sourceMappingURL=index.js.map